import * as React from 'react';

const RouterContext = /*#__PURE__*/React.createContext(undefined);
function RouterProvider({
  children,
  link: Link,
  router,
  baseHref
}) {
  return /*#__PURE__*/React.createElement(RouterContext.Provider, {
    value: {
      Link,
      router,
      baseHref
    }
  }, children);
}
function useLink() {
  const context = React.useContext(RouterContext);
  if (context === undefined) {
    throw new Error('useLink must be used within a RouterProvider');
  }
  return {
    Link: context.Link,
    baseHref: context.baseHref
  };
}
function useRouter() {
  const context = React.useContext(RouterContext);
  if (context === undefined) {
    throw new Error('useLink must be used within a RouterProvider');
  }
  return context.router;
}

export { RouterProvider, useLink, useRouter };
